export enum SearchSize {
    REGULAR = "regular",
    BIG = "big",
}
